
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33 25","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.828 18.326c.28-.689.43-1.145.644-1.568a1622.06 1622.06 0 014.58-8.979c.607-1.182.92-1.209 1.782-.197 1.55 1.82 3.098 3.644 4.642 5.47.91 1.077 1.387 1.102 2.346.094.243-.257.454-.546.71-.79.587-.561 1.174-.652 1.628.143a249.68 249.68 0 012.652 4.744c.386.71.14 1.084-.68 1.084-6.02-.003-12.041-.001-18.304-.001zM23.443 6.439c1.016-.039 1.93.838 1.976 1.894.047 1.084-.74 1.978-1.794 2.04-1.145.067-2.035-.764-2.052-1.916-.015-1.03.865-1.98 1.87-2.018z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M29.99.357H3.013A2.264 2.264 0 00.75 2.621v19.3a2.264 2.264 0 002.264 2.265H29.99a2.264 2.264 0 002.264-2.264v-19.3A2.264 2.264 0 0029.99.356zm-1.863 19.636H4.876V4.55h23.251v15.442z","clip-rule":"evenodd"}})])
          )
        }
      }
    